import dayjs from '../libs/dayjs'

export function calculateDateRange(data_Liquidacao: string, index: number) {
    let dataLiquidacao = dayjs(data_Liquidacao).add(index, 'month')
    let dataLiquidacaoInicial = dataLiquidacao
    if (dataLiquidacao.day() === 0) {
        dataLiquidacaoInicial = dayjs(dataLiquidacao).add(1, 'd')
    }

    if (dataLiquidacao.day() === 6) {
        dataLiquidacaoInicial = dayjs(dataLiquidacao).add(2, 'd')
    }

    let dataLiquidacaoFinal = dayjs(dataLiquidacaoInicial).add(3, 'd')
    if (dayjs(dataLiquidacaoInicial).add(3, 'd').day() === 0) {
        dataLiquidacaoFinal = dayjs(dataLiquidacaoFinal).add(2, 'd')
    }

    if (dayjs(dataLiquidacaoInicial).add(3, 'd').day() === 6) {
        dataLiquidacaoFinal = dayjs(dataLiquidacaoFinal).add(2, 'd')
    }

    if (dayjs(dataLiquidacaoInicial).add(3, 'd').day() === 1) {
        dataLiquidacaoFinal = dayjs(dataLiquidacaoFinal).add(2, 'd')
    }

    return {
        dataLiquidacaoInicial,
        dataLiquidacaoFinal,
    }
}
